import { IApplicationState } from '../../types/redux';

export const selectHasMoreOffers = (state: IApplicationState) => {
  return state.listingOffers.hasMoreOffers;
};
